import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import {  useShowColumsHook } from '../../../hooks/useShowColums';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { headTbl, TblHAnunciosUS } from '../../../data/tables';
import { useGetDta } from '../../../hooks/useGetDta';
import LoadinSpin from '../../ui/LoadinSpin';
import Confirmation from '../../ui/Confirmation';
import Table from '../../Table';
import DropDownsCol from '../../ui/DropDownsCol';
import { getInitialColumns } from '../../../data/cards';  


const baseUrl = process.env.REACT_APP_API;
const AvisosScreen = ({ activeTab,eliminar }) => {
    const { id } = useParams();

    let idR = atob(id);
    const { loading, data, getInfo } = useGetDta(`proxy/anuncios/user`, { id: idR }, 'POST');

    const initialColums = getInitialColumns('anuncios/user', TblHAnunciosUS);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'anuncios/user');

    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});
    const [zoom, setZoom] = useState();
    const [modal, setModal] = useState(false);
    useEffect(() => {
        getInfo();
    }, [activeTab, idR]);

    if (loading) return <LoadinSpin />;
    const showImg = (url) => {
        setZoom(url);
        setModal(true);
    };

    const ActionColumn = ({ row }) => {
        return (
            <>
          
                <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Borrar</Tooltip>}>
                    <i className="mdi mdi-delete mdi-18px " onClick={() => dele(row.original.ids)}></i>
                </OverlayTrigger>
            </>
        );
    };
    const Imagen = ({ row }) => {
        return (
            <>
                <img
                    src={baseUrl + row.original.foto}
                    alt="FOTO"
                    width={'50px'}
                    onClick={() => showImg(row.original.foto)}
                />
            </>
        );
    };
    const fechaCell = ({ row }) => {
        return (
            <>
                {moment(
                    `${row.original.now === 1 ? row.original.createdAt : `${row.original.fecha} ${row.original.hora}`}`
                ).format('YYYY-MM-DD HH:mm:ss')}{' '}
            </>
        );
    };
    const StateCell = ({ row }) => {
        return (
            <span
                className={classNames('badge', {
                    'bg-success': row.original.estate === 'ENVIADO',
                    'bg-info': row.original.estate === 'PENDIENTE',
                    'bg-danger': row.original.estate === 'MOROSO',
                })}>
                {row.original.estate}
            </span>
        );
    };
    const IpCell = ({ row }) => {
        return (
            <div className="r">
                {row.original.emit}
                <span className={classNames('badge bg-info mx-2')}>{row.original.ipe}</span>
            </div>
        );
    };
    const TipoCell = ({ row }) => {
        return <span className="badge bg-info ">{row.original.type}</span>;
    };

    const columns = [
        {
            Header: 'Tipo',
            accessor: 'type',
            sort: true,
            Cell: TipoCell,
        },
        {
            Header: 'Imagen',
            accessor: 'foto',
            sort: true,
            Cell: Imagen,
        },
        {
            Header: 'Nombre',
            accessor: 'nombre',
            sort: true,
        },
        {
            Header: 'Descripción',
            accessor: 'descripcion',
            sort: true,
        },

        {
            Header: 'Emitido por ',
            accessor: 'emit',
            sort: true,
            Cell: IpCell,
        },

        {
            Header: 'Fecha de emisión',
            accessor: 'fecha',
            sort: true,
            Cell: fechaCell,
        },
        {
            Header: 'Estado',
            accessor: 'estate',
            sort: true,
            Cell: StateCell,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    const dele = (id, idus) => {
        setInfo({ id, type: 'SCREEN-USUARIO' });
        setShowd(true);
    };
    return (
        <div>
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />

            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                columnasVisibles={columnasVisibles}
                theadClass="table-light"
                searchBoxClass="mb-2"
                visiblesCustum={
                    <DropDownsCol
                        cols={columnasVisibles} // Pasar el estado desde TblZonas
                        toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                    />
                }
            />
            <Modal size="lg" centered show={modal} onHide={() => setModal(false)}>
                <img src={baseUrl + `${zoom}`} alt="ANUNCIO" width={'100%'} />
            </Modal>
        </div>
    );
};

export default AvisosScreen;
